export const selects = {
  selects: {
    dateSelect: {
      last30min: "Son 30 Dakika",
      last1hour: "Son 1 Saat",
      last3hours: "Son 3 Saat",
      last1day: "Son 1 Gün",
      last3days: "Son 3 Gün",
      last7days: "Son 7 Gün",
      custom: "Özel",
    },
  },
};
